import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import { useTheme } from '@mui/material'
import { useOrganizationView } from 'api/aws/organizations_table/useOrganizationView'
import HeaderLoading from 'components/Loading/HeaderLoading'
import { useMemo } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { PageContainer, PageHeader, PageHeaderChip, TabConfig, TabNavigation } from 'theme/components'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'

const OrganizationPage = () => {
  const { PK } = useParams()
  const { pinned, expanded } = useLayoutContext()
  const { organization, isItemsLoading } = useOrganizationView(PK)
  const theme = useTheme()

  const chips: PageHeaderChip[] = useMemo(() => {
    const result: PageHeaderChip[] = []
    if (organization?.type) {
      result.push({ label: organization.type, tooltip: 'Type' })
    }
    if (organization?.status) {
      result.push({ label: organization.status, tooltip: 'Status' })
    }
    return result
  }, [organization?.type, organization?.status])

  const tabs: TabConfig[] = useMemo(
    () => [
      { label: 'Details', path: 'details' },
      { label: 'Deals', path: 'deals' },
      { label: 'Agreements', path: 'agreements' },
      { label: 'Products', path: 'products' },
      { label: 'Contacts', path: 'contacts' },
      { label: 'Tasks', path: 'tasks' },
      { label: 'Comments', path: 'comments' },
      { label: 'Integration', path: 'integration' },
      { label: 'Heartbeat', path: 'heartbeat' },
      { label: 'Organizations', path: 'relatedorgs' },
    ],
    []
  )

  return (
    <>
      <PageHeader
        name={organization?.name || ''}
        photoUrl={organization?.photoUrl}
        avatarColor={theme.palette.icon.organizations}
        icon={<CorporateFareIcon sx={{ color: theme.palette.icon.organizations }} />}
        iconColor={theme.palette.icon.organizations}
        title="Organization Details"
        verticals={
          Array.isArray(organization?.vertical)
            ? organization.vertical
            : organization?.vertical
            ? [organization?.vertical]
            : []
        }
        maxVerticals={1}
        chips={chips}
        isLoading={isItemsLoading}
        loadingComponent={<HeaderLoading chipCount={2} />}
      />

      <TabNavigation tabs={tabs} basePath={`/organizations/${PK}`} scrollable={true} />

      <PageContainer height="calc(100vh - 110px)">
        <Outlet context={{ pinned, expanded, organization }} />
      </PageContainer>
    </>
  )
}

export default OrganizationPage
